import React, { useEffect } from "react";
import { getSitesList } from "./action";
import { useDispatch, useSelector } from "react-redux";
import SitesTable from "../../components/sitesTable";

/**
 * @function Sites
 * @description for Sites
 * @returns JSX for Sites
 */

const Sites = () => {
  const { pageNo, limit, searchKey, sortOrder } = useSelector(
    (state) => state.SiteReducer
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSitesList());
  }, [pageNo, limit, searchKey, sortOrder]);


  return (
    <div>
      <SitesTable />
    </div>
  );
};

export default Sites;
